import { gql } from '@apollo/client';

const CommissionTransactionsSubscription = gql`
  subscription CommissionTransactions {
    commissionTransactions {
      commissionChange {
        currentBalance
        delta
      }
    }
  }
`;

export default CommissionTransactionsSubscription;
